import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../permission/authentication.service';
import { LogService } from '../util/log.service';

/**
 * A Stay reggeli-rendelések nézet route-őre.
 *
 * A `requiredPermissions`-alapú {@link RoleGuard} itt nem használható: a szabály a
 * felhasználó TELJES szerepkör-halmazát nézi ("pontosan {ROLE_USER, ROLE_ADMIN_API}"),
 * a jogosultság-feloldás viszont szerepkörönként dolgozik. A döntés egyetlen helyen,
 * az {@link AuthenticationService.canAccessStayOrders} metódusban él.
 */
@Injectable({
  providedIn: 'root'
})
export class StayOrdersGuard {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthenticationService,
    private readonly log: LogService
  ) {}

  canActivate(): boolean {
    if (this.authService.canAccessStayOrders()) {
      return true;
    }
    this.log.warn('StayOrdersGuard: user may not access the Stay breakfast orders view. Access denied.');
    this.router.navigate(['/auth/access'], { queryParams: { needed: 'stay-orders' } });
    return false;
  }
}
